// extracted by mini-css-extract-plugin
module.exports = {"partnersUsers":"U4tGq"};